import { l } from "./debug/debug";
import "src/js/what-input.js";
import { Site } from "./site/Site";
class Main {
    constructor() {
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", () => this.init());
        }
        else {
            this.init();
        }
    }
    init() {
        l('   Dom loaded. Init site.');
        this.site = new Site();
    }
}
new Main();
